import SetEligibleExpenses from 'adminDashboard/benefitDetails/common/productClassWizardModal/components/setEligibleExpenses'

import { IchraSelectReimbursementProductRequest, selectIchraReimbursementProduct } from 'core'

import { useCommandRequestV2 } from 'common/hooks'

import { BaseComponentProps } from '../../../../../common/productClassWizardModal/Common'

export type SetEligibleExpensesFormProps = {
  productClassId: string
  reimbursementProduct?: number
}

const SetEligibleExpensesForm = (props: BaseComponentProps<SetEligibleExpensesFormProps>) => {
  const { sendCommand } = useCommandRequestV2((request: IchraSelectReimbursementProductRequest) =>
    selectIchraReimbursementProduct(request),
  )

  return <SetEligibleExpenses {...props} commandHandler={sendCommand} />
}

export default SetEligibleExpensesForm
